"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForLoopComponentParameters = void 0;
exports.ForLoopComponentParameters = [
    {
        id: 'array',
        label: 'Input Array',
        description: 'Input Param - Array of ITER inputs',
        type: 'json_array',
        paramType: 'ARRAY',
        required: true,
    },
    {
        id: 'output',
        label: 'Output',
        description: 'Output Param - Array of outputs of loop component',
        type: 'output',
        paramType: 'ARRAY',
        required: true,
    },
    {
        id: 'spec',
        label: 'Loop specification',
        description: 'Specification used by generic task to iterate over the objects in the input array',
        type: 'json',
        paramType: 'SPEC',
        required: true,
    },
];
//# sourceMappingURL=ForLoop.js.map